import { render, staticRenderFns } from "./create-registration-popups.vue?vue&type=template&id=91977e46"
import script from "./create-registration-popups.vue?vue&type=script&lang=js"
export * from "./create-registration-popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports